import { Accordion, FaroText, grey } from "@faro-lotv/flat-ui";
import { PropsWithChildren, type JSX } from "react";

type DebugOverlaySectionProps = PropsWithChildren<{
  title: string;

  /** True to start expanded */
  defaultExpanded?: boolean;
}>;

/** @returns a single section included in the rendering debug overlay. */
export function DebugOverlaySection({
  title,
  children,
  defaultExpanded,
}: DebugOverlaySectionProps): JSX.Element {
  return (
    <Accordion
      title={
        <FaroText dark variant="heading12">
          {title}
        </FaroText>
      }
      isDefaultExpanded={defaultExpanded}
      // The overlay is dark: the expand icon inherits this colour
      sx={{ color: grey[100] }}
    >
      {children}
    </Accordion>
  );
}
